export const scrollToBottom = (ref: React.RefObject<HTMLDivElement>) => {
  if (ref.current) {
    const scrollHeight = ref.current.scrollHeight;
    const clientHeight = ref.current.clientHeight;
    ref.current.scrollTop = scrollHeight - clientHeight;
  }
};
